export default __webpack_public_path__ + "static/stage-2_6-2dfb282308f277499ff7527a121a3a85.jpg";